import React, { useEffect, useState } from 'react';
import social2 from '../../../../assets/shapes_svg/output/social2.svg';
import { getHighlight } from '../../../../apis/Ambition';
import { useRef } from 'react';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';

export const OurHealth = () => {
  const [text1, setText1] = useState();
  const [text2, setText2] = useState();
  const [text3, setText3] = useState();
  const [text4, setText4] = useState();
  const [text5, setText5] = useState();
  const [text6, setText6] = useState();
  const [text7, setText7] = useState();
  const [text8, setText8] = useState();
  const [text9, setText9] = useState();
  const [text10, setText10] = useState();
  const [text11, setText11] = useState();

  const [question1, setQuestion1] = useState();
  const [question2, setQuestion2] = useState();
  const [question3, setQuestion3] = useState();
  const [question4, setQuestion4] = useState();
  const [question5, setQuestion5] = useState();
  const [question6, setQuestion6] = useState();
  const [question7, setQuestion7] = useState();
  const [question8, setQuestion8] = useState();
  const [question9, setQuestion9] = useState();
  const [question10, setQuestion10] = useState();
  const [question11, setQuestion11] = useState();

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({ key: "employeehealth", setValue: setText1 });
    getHighlight({ key: "offgassing", setValue: setText2 });
    getHighlight({ key: "smoking", setValue: setText3 });
    getHighlight({ key: "physicalactivity", setValue: setText4 });
    getHighlight({ key: "meals", setValue: setText5 });
    getHighlight({ key: "physicalpain", setValue: setText6 });
    getHighlight({ key: "stress", setValue: setText7 });
    getHighlight({ key: "physicalwellbeing", setValue: setText8 });
    getHighlight({ key: "mentalwellbeing", setValue: setText9 });
    getHighlight({ key: "holistic", setValue: setText10 });
    getHighlight({ key: "benefit", setValue: setText11 });

    getHighlight({ key: "employeehealth_question", setValue: setQuestion1 });
    getHighlight({ key: "offgassing_question", setValue: setQuestion2 });
    getHighlight({ key: "smoking_question", setValue: setQuestion3 });
    getHighlight({ key: "physicalactivity_question", setValue: setQuestion4 });
    getHighlight({ key: "meals_question", setValue: setQuestion5 });
    getHighlight({ key: "physicalpain_question", setValue: setQuestion6 });
    getHighlight({ key: "stress_question", setValue: setQuestion7 });
    getHighlight({ key: "physicalwellbeing_question", setValue: setQuestion8 });
    getHighlight({ key: "mentalwellbeing_question", setValue: setQuestion9 });
    getHighlight({ key: "holistic_question", setValue: setQuestion10 });
    getHighlight({ key: "benefit_question", setValue: setQuestion11 });
  };
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>Our Health</h4>
        <img src={social2} alt="" />
      </div>
      <div className="environmentalaim__body ">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}>{question1 + "\n" + text1 +
          "\n\n" +
          question2 + "\n" + text2 +
          "\n\n" +
          question3 + "\n" + text3 +
          "\n\n" +
          question4 + "\n" + text4 +
          "\n\n" +
          question5 + "\n" + text5 +
          "\n\n" +
          question6 + "\n" + text6 +
          "\n\n" +
          question7 + "\n" + text7 +
          "\n\n" +
          question8 + "\n" + text8 +
          "\n\n" +
          question9 + "\n" + text9 +
          "\n\n" +
          question10 + "\n" + text10 +
          "\n\n" +
          question11 + "\n" + text11}</h5>
      </div>
    </div>
  );
};
